export const TEMPLATES = {
    GENERAL: 'General Layout',
    DYNAMIC: 'Dynamic',
    GLOBAL_COMPONENTS: 'Global Components',
    CONTACT: 'Contact',
    GALLERY: 'Gallery',
    HOTEL: 'Hotel',
    HOTELS: 'Hotel List',
    ROOMS: 'Roomsv1',
    ROOMS2: 'Roomsv2',
    RENTINGS: 'Rentings',
    ROOM_DETAIL: 'Room',
    DESTINATIONS: 'Destinations',
    PROMO_DETAIL: 'offer',
    LIST_PROMOS: 'Promosv1',
    LIST_PROMOS_V2: 'Promosv2',
    LOCATION: 'Location',
    LEGAL: 'Legal',
    EMPLOYMENT: 'Employment',
    WEBMAP: 'Webmap',
    THANKS: 'Thanks',
    FAQ: 'Faq',
    LOYALTY: 'loyalty',
    COMINGSOON: 'Coming Soon',
    404: '404',
    BLOG_LIST: 'Blog List',
    BLOG_DETAIL: 'Blog Detail',
};
